import {l} from "types/typescriptdefinisjoner_lederplan";
import {Kontekst} from "../Kontekst";


export class OppgaveTjeneste {

    static regNavn = "oppgaveTjeneste";

    static forInjisering() {
        return [Kontekst.regNavn, OppgaveTjeneste]
    }
    
    constructor(private kontekst: Kontekst) {
    }

    /*
    Brukes for å avgjøre om rediger/slett knapp på oppgave kan vises
    */
    kanOppgaveRedigeres(oppgave: l.OppgaveModell): boolean {
        return oppgave.harForelder || oppgave.ansvarlig == null ?
          this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, oppgave.eiendeGruppeId) :
          oppgave.ansvarlig.brukerId === this.kontekst.autentisertBrukersId();
    }
}
